import { TMap } from '@client/new/helpers/types';
import {
  ComplexStyleRule,
  StyleRule,
  style as orgStyle,
} from '@vanilla-extract/css';
import { breakpoints } from './tokens';

const minWidth = (v: number) => `(min-width: ${v}px)`;
const maxWidth = (v: number) => `(max-width: ${v}px)`;

const bpoitns = {
  mobile: maxWidth(breakpoints.mobile.max),
  tablet: minWidth(breakpoints.tablet.min),
  desktop: minWidth(breakpoints.desktop.min),
  largeDesktop: minWidth(breakpoints.largeDesktop.min),
};

type MediaParams = Partial<TMap<keyof typeof bpoitns, ComplexStyleRule>>;
const media = (v: MediaParams) => ({
  '@media': (Object.keys(v) as Array<keyof typeof bpoitns>).reduce(
    (acc, key) => ({
      ...acc,
      [bpoitns[key]]: v[key],
    }),
    {},
  ),
});

const isMediaParams = (v: any): v is MediaParams =>
  // eslint-disable-next-line implicit-arrow-linebreak
  typeof v === 'object' &&
  Object.keys(v).every((k) => Object.keys(bpoitns).includes(k));
type S = ComplexStyleRule | string | MediaParams;

export function style(rule1: S): string;
export function style(rule1: S, rule2: S): string;
export function style(rule1: S, rule2: S, rule3: S): string;
export function style(rule1: S, rule2?: S, rule3?: S): string {
  const rs = [rule1, rule2, rule3]
    .filter(Boolean)
    .map((r) => (typeof r === 'object' && isMediaParams(r) ? media(r) : r));

  return orgStyle(rs as Array<StyleRule>);
}

import { useState, useEffect } from 'react';
import autoAnimate from '@formkit/auto-animate';

export function useAutoAnimateSafe(options: Parameters<typeof autoAnimate>[1]) {
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (node && typeof node.animate === 'function') {
      autoAnimate(node, options);
    }
  }, [node, options]);

  return [setNode] as const;
}
